import {useParams} from "react-router-dom";

export default function ViewIssuu() {
	// use tailwind css

	window.scrollTo(0, 0);

	const {issuuId} = useParams();

	return <div className='flex flex-col items-center justify-center min-h-screen py-2'>

		<div style={{
		position: 'relative',
		paddingTop: 'max(90vh)',
		height: '0',
		width: '100%',
		maxHeight: '30vh',
		maxWidth: '98vw'
	}}>
		<iframe allow="clipboard-write"
				sandbox="allow-top-navigation allow-top-navigation-by-user-activation allow-downloads allow-scripts allow-same-origin allow-popups allow-modals allow-popups-to-escape-sandbox allow-forms"
				allowFullScreen="true"
				style={{
					position: 'absolute',
					border: 'none',
					width: '100%',
					height: '100%',
					left: '0',
					right: '0',
					top: '0',
					bottom: '0'
				}}
				src={`https://e.issuu.com/embed.html?d=${issuuId}&u=vbmedia`}></iframe>
	</div>
	</div>
}